import { getAuth } from "firebase/auth";
import { ClerkAuthProvider } from "./clerk-auth";
import { signInWithClerkToken } from "./firebaseAuth";
import logging from "utils/logging";

const log = logging.getLogger("ensureFirebaseAuth");

/**
 * Ensures Firebase auth is established before a client write/read that the
 * Firestore security rules gate on `request.auth` (e.g. games update →
 * isCreator). The Clerk→Firebase bridge in clerk-auth.js is async and can lag —
 * notably right after load and under the emulator — so a write can otherwise
 * race ahead of auth and hit PERMISSION_DENIED. This re-runs the token exchange
 * on demand. Shared by every provider that does a rule-gated client write.
 */
export const ensureFirebaseAuth = async () => {
  if (getAuth().currentUser) return;

  log.warn("Firebase auth not established — re-triggering Clerk token exchange");

  const provider = ClerkAuthProvider.getInstance();
  let token = null;
  try {
    token = await provider.clerk?.session?.getToken({ template: "firebase" });
  } catch (_) { /* fall through */ }
  if (!token) {
    try {
      token = await provider.clerk?.session?.getToken();
    } catch (_) { /* fall through */ }
  }

  if (!token) {
    throw new Error("Could not obtain an authentication token. Please sign out and sign back in.");
  }

  await signInWithClerkToken(token);

  if (!getAuth().currentUser) {
    throw new Error("Authentication failed. Please refresh the page and try again.");
  }
};

export default ensureFirebaseAuth;
